import { render } from "./wishlist_card.vue?vue&type=template&id=b53a4da4"
import script from "./wishlist_card.vue?vue&type=script&lang=js"
export * from "./wishlist_card.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__